<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FM-Epigraph-non-verse-fmepi">“Spooky action at a distance” is how Albert Einstein famously derided the concept of quantum entanglement—where objects can become linked and instantaneously influence one another regardless of distance.</p>
<div class="top1">
<p class="FM-Epigraph-Source-fmeps">—Charles Q. Choi, <span class="ePub-I">Scientific American</span></p>
<p class="FM-Epigraph-non-verse-fmepi-first">Fundamental biology tells us that survival is the name of the game. So potent is this dictate that in 1973 the psychologist Ernest Becker won a Pulitzer Prize for <span class="ePub-I">The Denial of Death,</span> arguing that everything we think of as civilization, from cities we build to the religions we believe in, is nothing beyond an elaborate symbolic defense mechanism against the awful knowledge of our own mortality.</p>
<div class="top1">
<p class="FM-Epigraph-Source-fmeps">—Steven Kotler, <span class="ePub-I">The Rise of the Superman: Decoding the Science of Ultimate Human Performance</span></p>
<p class="PGBREAK"></p>
<p class="sp1"> </p>
<p class="FM-Epigraph-non-verse-fmepi-first">Shakti asks: “Oh Shiva, what is your reality? What is this wonder-filled universe? What constitutes seed? Who centers the universal wheel? What is this life beyond form pervading forms? How may we enter it fully, above space and time, names and descriptions? Let my doubts be cleared.”</p>
<div class="top1">
<p class="FM-Epigraph-Source-fmeps">—<span class="ePub-I">The Vigyan Bhairav Tantra</span></p>
<p class="FM-Epigraph-non-verse-fmepi-first">Kali asks: “Oh Yama, what is your reality? What is this terrible universe? What constitutes the cessation of breath? Who stills the universal wheel? What is this ending of life, the dissolution of form? How may we depart it fully, ending space and time, names and descriptions? Let my fears be cleared.”</p>
<div class="top1">
<p class="FM-Epigraph-Source-fmeps">—<span class="ePub-I">The Yama Sutra</span></p>
</div></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?8756f990